const CryptoJS = require("crypto-js");
const secretKey = "mySecretKey123456";

export function setDataOnLocalStorage(key, data) {
  localStorage.setItem(key, encrypt(JSON.stringify(data)));
}

export function getDataFromLocalStorage(key) {
  const data = localStorage.getItem(key);
  if (!data) return null;
  try {
    return decrypt(data);
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function removeStorageItem(key) {
  localStorage.removeItem(key);
}

export function encrypt(data) {
  return CryptoJS.AES.encrypt(data, secretKey);
}

export function decrypt(data) {
  let decrypted = CryptoJS.AES.decrypt(data, secretKey);
  const str = decrypted.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(str);
  } catch {
    return str;
  }
}
